import Image from 'next/image';
import { RichText } from 'prismic-reactjs';
import { Hero, ImageBackground } from 'remote-com-shared/components/Hero';
import { Content } from 'remote-com-shared/components/Hero/styles';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { transformProperties } from '@/src/domains/prismic/helpers';
import { tabletBreakpoint, fromTabletBreakpoint } from '@/src/domains/shared/breakpoints';

const HeroBackground = styled(ImageBackground)`
  right: 0;
  bottom: 10%;
  display: flex;
  max-width: 50%;

  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

const EntityCostHero = styled(Hero)`
  ${Content} {
    ${fromTabletBreakpoint(css`
      ${fluidProp('--spacing-y', '122px', '122px')}
    `)}
  }
`;

export function HeroSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, description, bgImage } = primary;

  return (
    <>
      <EntityCostHero
        title={<RichText render={title} />}
        description={<RichText render={description} />}
        background={
          <HeroBackground as="div">
            <Image
              src={bgImage.url}
              alt={bgImage.alt || ''}
              width={bgImage.dimensions.width}
              height={bgImage.dimensions.height}
              quality="100"
              priority
            />
          </HeroBackground>
        }
        preview="0vh"
      />
    </>
  );
}
